import Cleave from 'cleave.js';
import { getBirthdayMaxDate, getBirthdayMinDate } from '../common/birthday-config';

export default function () {
  const list = document.querySelectorAll('.js-birthday');

  if (!list.length) return;

  list.forEach((item) => {
    new Cleave(item, {
      date: true,
      delimiter: '-',
      datePattern: ['d', 'm', 'Y'],
      dateMin: getBirthdayMinDate(),
      dateMax: getBirthdayMaxDate(),
    });
  });
}
